import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'

const SlowestTestCaseInfo = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        This report highlights the top 10 slowest test case runs, providing crucial insights into the execution time of your tests. It showcases both the maximum and average time taken for each test case, allowing you to identify potential bottlenecks and optimize your testing process.
        <br />
        <br />
        Key Features:
        <br />
      </Color>
    </Paragraph>
    <List variant='description'>
      <Paragraph>
        <Color variant='theme-description-text'>
          Detailed Execution Time: View the maximum and average execution time for each test run, enabling you to understand the performance of your test cases.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Model and Suite: Associate which model or suite each test case belongs to, facilitating targeted analysis and troubleshooting.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Access Test Case Results: Dive deeper into individual test case results to gain a comprehensive understanding of their execution details.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Test Case Actions: Easily access the actions menu to view a specific test case, allowing for edit and further investigation.
        </Color>
      </Paragraph>
    </List>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        With the Top 10 Slowest Test Case Runs Report, you have a powerful tool to identify and address performance issues, optimize your testing efforts, and ensure efficient execution of your test cases.
      </Color>
    </Paragraph>
  </>

export default SlowestTestCaseInfo
